import * as cartApi from '../../helpers/cartApi';
import quickShop from './ProductQuickShop';
import { updateReactCart } from '../../preact/helpers/utilities';

const selectors = {
  quickShopTrigger: '[data-quickshop-trigger]',
  addToCart: '[data-add-to-cart]',
};

/**
 * A single product item in a collection / list of products
 *
 * @export
 * @class ProductItem
 */
export default class ProductItem {
  /**
   * Creates an instance of ProductItem.
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.el = el;
    this.addToCart = this.el.querySelector(selectors.addToCart);

    this._initQuickShop();
    this._initAddToCart();
  }

  /**
   * Bind quickshop to a trigger
   */
  _initQuickShop() {
    const trigger = this.el.querySelector(selectors.quickShopTrigger);

    if (!trigger) {
      return;
    }

    trigger.addEventListener('click', () => {
      const { productUrl, productHash } = this.el.dataset;

      quickShop.open(productUrl, productHash);
    });
  }

  /**
   * Bind add to cart button to cart api
   */
  _initAddToCart() {
    const variantId = this.addToCart.dataset.addToCart;

    this.addToCart.addEventListener('click', () => {
      cartApi
        .add({ items: [{ id: variantId, quantity: 1 }] })
        .then(() => {
          updateReactCart(true);
        })
        .catch(response => this._handleCartApiError(response));
    });
  }

  /**
   * Generic error handler for cart api
   * Example: 422 response when trying to add a product whose total stock is already in cart
   *
   * @param {Object} response The response from Shopify
   */
  _handleCartApiError = response => {
    const { message, status } = response;
    if (status === 422) {
      this.addToCart.disabled = true;
      this.addToCart.textContent = 'Out of Stock';
    }
    // eslint-disable-next-line no-console
    console.error(message);
  };
}
